let StoreReviews = (() => {
    let __pageSize = 10; // pagination page size
    let reviews = []; // Initialize empty array for review objects
    let ratingsAvg = 0; // Initialize ratings average
    // Assign to store_location cookie value if it exists.  If it does not exist, assign to store_location parameter value.
    let store = Util.getCookie('store_location') ? Util.getCookie('store_location') : Util.getParameterByName('store_location');

    /**
     * Initializes StoreReviews
     * @param {array of objects} reviews // response from lambda endpoint
     */
    let init = async () => {   

        try {
            const storeMetaReviewData = await jQuery.ajax({
                url: `${Util.lambdaHost}reviews/stores/aggregate?store=${store}`,
                type: 'GET',
                headers: {
                    'x-api-key': Util.lambdaApiKey
                }
            });

            if (storeMetaReviewData['GoogleAvg'] >= 4) {
                ratingsAvg = storeMetaReviewData['GoogleAvg']
                storeMetaReviewData['isGoogle'] = true;
            }
            else {
                ratingsAvg = storeMetaReviewData['AllAvg']
                storeMetaReviewData['isGoogle'] = false;
            }

            const storeReviewsData = await jQuery.ajax({
                url: storeMetaReviewData['isGoogle'] ? `${Util.lambdaHost}/reviews/stores?filter=google&store=${store}` : `${Util.lambdaHost}/reviews/stores?store=${store}`,
                type: 'GET',
                headers: {
                    'x-api-key': Util.lambdaApiKey
                }
            })

            reviews = storeReviewsData;
            jQuery('.reviews-store-info-wrapper').children('.star-rating').prepend(`${Util.lookupStarRating(ratingsAvg)}`);
            
        } catch (error) {
            console.error(`An error has occurred: ${error}`);
        }

        __paginationInit();
        LocationFlyout.lookupDayOfWeek('.reviews-store-hours-list > li > .reviews-store-day', true);
    }

    /**
     * Paginates the results using paginationjs, documentation here: http://pagination.js.org/docs/index.html
     */
    let __paginationInit = () => {
        jQuery('#pagination-container').pagination({
            dataSource: reviews,
            pageSize: __pageSize,
            prevText: 'previous',
            nextText: 'next',
            callback: function (data, pagination) {
                __populateReviewResult(data);

                if (data.length <= 0) {
                    var tireError = `<h3 class="tire-error">No Results Found</h3>`;
                    jQuery('.tire-detail-review').html(tireError);
                    jQuery('#results-shown').text("0");
                    jQuery('#total-results').text("0");
                    jQuery('.reviews-count').text("0")
                    return;
                } else {
                    var displayString = '0';
                    if (pagination.pageNumber === 1 && pagination.totalNumber > 0) {
                        if (pagination.totalNumber <= pagination.pageSize) {
                            displayString = '1 - ' + pagination.totalNumber;
                        } else {
                            displayString = '1 - ' + (pagination.pageSize);
                        }
                    } else if (pagination.totalNumber > 0) {
                        var startNum = (pagination.pageNumber - 1) * pagination.pageSize + 1;
                        var endNum = startNum + pagination.pageSize - 1;
                        displayString = startNum + ' - ' + Math.min(endNum, pagination.totalNumber);
                    }

                    jQuery('#results-shown').text(displayString);
                    jQuery('#total-results').text(pagination.totalNumber);
                    jQuery('.reviews-count').text(pagination.totalNumber);
                }
            },
            afterNextOnClick: function () {
                Util.scrollToTop();
            },
            afterPreviousOnClick: function () {
                Util.scrollToTop();
            }
        });
    }

    let __populateReviewResult = (reviewArr) => {
        var reviewResult = reviewArr.reduce((accumulator, {
            Comment, // string
            DateAdded, // string
            DateReviewed, // string, space separating date and time, we'll split on the space to get the date
            Id, // int
            RecordId, // string
            ReviewerName, // string
            Source, // string
            StoreId, // int
            StoreRating, // int
            ...review // rest of object
        }) => {
            return accumulator += `
                <div class="detail-review-block">
                    <span class="tire-detail-rating"> ${Util.lookupStarRating(StoreRating)}</span>
                    <p class="review-date"> ${DateReviewed.substr(0, DateReviewed.indexOf(' '))} ${ReviewerName ? ' By ' + ReviewerName : ''}</p>
                    ${Comment ? `<p class="review-text">${Comment}</p>` : `` }
                </div>
            `;
        }, '');

        jQuery('.tire-detail-review').html(reviewResult);
    }

    // removes reviews with blank or null comment and sorts by date
    let __filterReviews = (reviews) => { // remove reviews whose comments are null or blank
        filteredReviews = reviews.filter((review) => {
            if (review.Comment === null) {
                return false;
            }
            return !(review.Comment.length === 0 || !review.Comment.trim());
        });

        // sort by date descending 
        filteredReviews.sort((a, b) => {
            a = new Date(a.DateReviewed);
            b = new Date(b.DateReviewed);
            return a > b ? -1 : a < b ? 1 : 0;
        });

        return filteredReviews;
    }

    return {
        init: init,
    }
})();